import { render, staticRenderFns } from "./UserDetailsRoute.vue?vue&type=template&id=2345722b"
import script from "./UserDetailsRoute.vue?vue&type=script&lang=js"
export * from "./UserDetailsRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports